import { loadCameraDevicePreview } from './camera-cloud';

/**
 * Handle camera socket events from Shelly:Gen2Report
 * Routes different event types to appropriate handlers
 */
export const handleCameraSocketEvent = (
	id: string,
	message: { type?: string; device?: { id?: string }; data?: unknown },
) => {
	if (!id || !message) {
		return;
	}

	switch (message.type) {
		case 'upload_complete':
			// Refresh the camera preview when a new recording is uploaded
			loadCameraDevicePreview(id);
			break;
	}
};
